export * from './divorced.component';
